const clearSelectedDevice = async ({ commit }) => {
  commit('SET_SELECTED_DEVICE', {});
  commit('SET_SELECTED_DEVICE_STATUS', {});
};

export default clearSelectedDevice;
